import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Cards from '../components/cards'
import Card from '../components/card'
import FooterMain from '../components/footer-main'
import './kawasaki-robotics.css'

const KawasakiRobotics = (props) => {
  return (
    <div className="kawasaki-robotics-container1">
      <Helmet>
        <title>
          Промышленные роботы Kawasaki Robotics | Официальный дилер в Казахстане
          и Узбекистане | Arcobo
        </title>
        <meta
          name="description"
          content="Arcobo — официальный дилер Kawasaki Robotics в Казахстане и Узбекистане. Универсальные 6-осевые промышленные роботы грузоподъёмностью от 3 до 80 кг для сварки, обслуживания станков и автоматизации производства."
        />
        <meta
          property="og:title"
          content="Промышленные роботы Kawasaki Robotics | Официальный дилер в Казахстане и Узбекистане | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo — официальный дилер Kawasaki Robotics в Казахстане и Узбекистане. Универсальные 6-осевые промышленные роботы грузоподъёмностью от 3 до 80 кг для сварки, обслуживания станков и автоматизации производства."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Промышленные роботы Kawasaki Robotics | Официальный дилер в Казахстане и Узбекистане | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo — официальный дилер Kawasaki Robotics в Казахстане и Узбекистане. Универсальные 6-осевые промышленные роботы грузоподъёмностью от 3 до 80 кг для сварки, обслуживания станков и автоматизации производства."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/kawasaki-robotics"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/kawasaki-robotics"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Промышленные роботы Kawasaki Robotics","item":"https://arcobo.tech/kawasaki-robotics"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name31"></HeaderMain>
      <Cards
        titleAs="h1"
        text="Универсальные 6-осевые промышленные роботы грузоподъемностью от 3 до 80 кг для сварки, обслуживания станков, сборки и автоматизации производственных процессов"
        text1={
          <Fragment>
            <span className="kawasaki-robotics-text100">
              Универсальные 6-осевые промышленные роботы грузоподъемностью от 3
              до 80 кг для сварки, обслуживания станков, сборки и автоматизации
              производственных процессов
            </span>
          </Fragment>
        }
        heading="Серия промышленных роботов RS"
        heading1={
          <Fragment>
            <span className="kawasaki-robotics-text101">
              Серия промышленных роботов RS
            </span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name11"
      ></Cards>
      <div className="kawasaki-robotics-container2">
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text102">
                <span>Грузоподъёмность: 3 кг</span>
                <br></br>
                <span>Радиус действия: 620 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,02 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text110">
                KAWASAKI ROBOTICS RS003N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs003n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS003N"
          rootClassName="cardroot-class-name81"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text111">
                <span>Грузоподъёмность: 7 кг</span>
                <br></br>
                <span>Радиус действия: 730 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,02 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text119">
                KAWASAKI ROBOTICS RS007N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs007-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS007"
          rootClassName="cardroot-class-name92"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text120">
                <span>Грузоподъёмность: 7 кг</span>
                <br></br>
                <span>Радиус действия: 930 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,03 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text128">
                KAWASAKI ROBOTICS RS007L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs007l-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS007L"
          rootClassName="cardroot-class-name91"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text129">
                <span>Грузоподъёмность: 13 кг</span>
                <br></br>
                <span>Радиус действия: 1 460 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,03 мм</span>
              </span>
            </Fragment>
          }
          heading="MX600 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text137">
                KAWASAKI ROBOTICS RS013N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs013n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS013N"
          rootClassName="cardroot-class-name82"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text138">
                <span>Грузоподъёмность: 15 кг</span>
                <br></br>
                <span>Радиус действия: 3 150 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX500 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text146">
                KAWASAKI ROBOTICS RS015X
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs015x-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS015X"
          rootClassName="cardroot-class-name83"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text147">
                <span>Грузоподъёмность: 20 кг</span>
                <br></br>
                <span>Радиус действия: 1 725 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,04 мм</span>
              </span>
            </Fragment>
          }
          heading="MX500 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text155">
                KAWASAKI ROBOTICS RS020N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs020n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS020N"
          rootClassName="cardroot-class-name84"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text156">
                <span>Грузоподъёмность: 25 кг</span>
                <br></br>
                <span>Радиус действия: 1 885 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,04 мм</span>
              </span>
            </Fragment>
          }
          heading="MX400 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text164">
                KAWASAKI ROBOTICS RS025N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs025n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS025N"
          rootClassName="cardroot-class-name85"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text165">
                <span>Грузоподъёмность: 30 кг</span>
                <br></br>
                <span>Радиус действия: 2 100 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX400 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text173">
                KAWASAKI ROBOTICS RS030N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs030n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS030N"
          rootClassName="cardroot-class-name86"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text174">
                <span>
                  Грузоподъёмность:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>50 кг</span>
                <br></br>
                <span>
                  Радиус действия:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>2 100 мм</span>
                <br></br>
                <span>
                  Количество осей:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>6</span>
                <br></br>
                <span>Повторяемость:</span>
                <span> ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX350 C Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text186">
                KAWASAKI ROBOTICS RS050N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs050n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS050N"
          rootClassName="cardroot-class-name87"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text187">
                <span>Грузоподъёмность: 80 кг</span>
                <br></br>
                <span>Радиус действия:  2 100 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX350 CW Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text195">
                KAWASAKI ROBOTICS RS080N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs080n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS080N"
          rootClassName="cardroot-class-name88"
        ></Card>
      </div>
      <Cards
        text="Высокопроизводительные роботы грузоподъемностью от 100 до 300 кг для перемещения деталей, сборки, точечной сварки и тяжелых производственных операций."
        text1={
          <Fragment>
            <span className="kawasaki-robotics-text196">
              Высокопроизводительные роботы грузоподъемностью от 100 до 300 кг
              для перемещения деталей, сборки, точечной сварки и тяжелых
              производственных операций.
            </span>
          </Fragment>
        }
        heading="Серия MX Pulse"
        heading1={
          <Fragment>
            <span className="kawasaki-robotics-text197">
              Серии промышленных роботов BX/ BXP
            </span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name2"
      ></Cards>
      <div className="kawasaki-robotics-container3">
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text198">
                <span>Грузоподъёмность: 100 кг</span>
                <br></br>
                <span>Радиус действия: 1 634 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text206">
                KAWASAKI ROBOTICS BX100S
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bx100s-300h.webp"
          imageAlt="Промышленный робот Kawasaki BX100S"
          rootClassName="cardroot-class-name65"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text207">
                <span>Грузоподъёмность: 100 кг</span>
                <br></br>
                <span>Радиус действия: 2 200 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX600 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text215">
                KAWASAKI ROBOTICS BX100N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bx100n-300h.webp"
          imageAlt="Промышленный робот Kawasaki BX100N"
          rootClassName="cardroot-class-name66"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text216">
                <span>Грузоподъёмность: 110 кг</span>
                <br></br>
                <span>Радиус действия: 1 634 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX350 C Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text225">
                KAWASAKI ROBOTICS BXP110S
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bxp110s-300h.webp"
          imageAlt="Промышленный робот Kawasaki BXP110S"
          rootClassName="cardroot-class-name77"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text226">
                <span>Грузоподъёмность: 110 кг</span>
                <br></br>
                <span>Радиус действия: 2 597 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX350 CW Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text234">
                KAWASAKI ROBOTICS BXP110L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bxp110l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BXP110L"
          rootClassName="cardroot-class-name78"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text235">
                <span>Грузоподъёмность: 130 кг</span>
                <br></br>
                <span>Радиус действия: 2 991 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,07 мм</span>
              </span>
            </Fragment>
          }
          heading="MX300 C Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text243">
                KAWASAKI ROBOTICS BX130Х
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bx130x-300h.webp"
          imageAlt="Промышленный робот Kawasaki BX130X"
          rootClassName="cardroot-class-name79"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text244">
                <span>Грузоподъёмность: 200 кг</span>
                <br></br>
                <span>Радиус действия: 2 597 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,04 мм</span>
              </span>
            </Fragment>
          }
          heading="MX500 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text252">
                KAWASAKI ROBOTICS BX200L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bx200l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BX200L"
          rootClassName="cardroot-class-name74"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text253">
                <span>Грузоподъёмность: 200 кг</span>
                <br></br>
                <span>Радиус действия: 3 412 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,07 мм</span>
              </span>
            </Fragment>
          }
          heading="MX400 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text261">
                KAWASAKI ROBOTICS BX200Х
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bx200x-300h.webp"
          imageAlt="Промышленный робот Kawasaki BX200X"
          rootClassName="cardroot-class-name75"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text262">
                <span>Грузоподъёмность: 200 кг</span>
                <br></br>
                <span>Радиус действия: 3 151 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,08 мм</span>
              </span>
            </Fragment>
          }
          heading="MX220 C Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text270">
                KAWASAKI ROBOTICS BT200L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bt200l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BT200L"
          rootClassName="cardroot-class-name80"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text271">
                <span>Грузоподъёмность: 250 кг</span>
                <br></br>
                <span>Радиус действия: 2 812 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,07 мм</span>
              </span>
            </Fragment>
          }
          heading="MX300 C Pulse"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text279">
                KAWASAKI ROBOTICS BXP210L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bxp210l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BXP210L"
          rootClassName="cardroot-class-name90"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text280">
                <span>Грузоподъёмность: 210 кг</span>
                <br></br>
                <span>Радиус действия: 3 151 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX500 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text288">
                KAWASAKI ROBOTICS BTP210L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_btp210l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BTP210L"
          rootClassName="cardroot-class-name67"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text289">
                <span>Грузоподъёмность: 300 кг</span>
                <br></br>
                <span>Радиус действия: 2 812 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,07 мм</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX400 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text298">
                KAWASAKI ROBOTICS BX300L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_bx300l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BX300L"
          rootClassName="cardroot-class-name76"
        ></Card>
      </div>
      <Cards
        text="Цифровые источники MIG/MAG с импульсным режимом для высококачественной сварки стали, нержавеющей стали и алюминия."
        text1={
          <Fragment>
            <span className="kawasaki-robotics-text299">
              Специализированные сварочные роботы для высокой повторяемостью
              сварочного процесса.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="kawasaki-robotics-text300">
              Серии сварочных роботов BA/ RA
            </span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name9"
      ></Cards>
      <div className="kawasaki-robotics-container4">
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text301">
                <span>Грузоподъёмность: 5 кг</span>
                <br></br>
                <span>Радиус действия: 903 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,03 мм</span>
              </span>
            </Fragment>
          }
          heading="MX500 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text309">
                KAWASAKI ROBOTICS RA005L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_ra005l-300h.webp"
          imageAlt="Промышленный робот Kawasaki RA005L"
          rootClassName="cardroot-class-name98"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text310">
                <span>Грузоподъёмность: 6 кг</span>
                <br></br>
                <span>Радиус действия: 1 445 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text318">
                KAWASAKI ROBOTICS BA006N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_ba006n-300h.webp"
          imageAlt="Промышленный робот Kawasaki BA006N"
          rootClassName="cardroot-class-name93"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text319">
                <span>Грузоподъёмность: 6 кг</span>
                <br></br>
                <span>Радиус действия: 2 036 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,08 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text327">
                KAWASAKI ROBOTICS BA006L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_ba006l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BA006L"
          rootClassName="cardroot-class-name94"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text328">
                <span>Грузоподъёмность: 13 кг</span>
                <br></br>
                <span>Радиус действия: 1 492 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,04 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text336">
                KAWASAKI ROBOTICS BA013N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_ba013n-300h.webp"
          imageAlt="Промышленный робот Kawasaki BA013N"
          rootClassName="cardroot-class-name95"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text337">
                <span>Грузоподъёмность: 13 кг</span>
                <br></br>
                <span>Радиус действия: 2 093 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX600 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text345">
                KAWASAKI ROBOTICS BA013L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_ba013l-300h.webp"
          imageAlt="Промышленный робот Kawasaki BA013L"
          rootClassName="cardroot-class-name96"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text346">
                <span>Грузоподъёмность: 15 кг</span>
                <br></br>
                <span>Радиус действия: 3 150 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,06 мм</span>
              </span>
            </Fragment>
          }
          heading="MX500 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text354">
                KAWASAKI ROBOTICS RA015X
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs015x-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS015X"
          rootClassName="cardroot-class-name97"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text355">
                <span>Грузоподъёмность: 20 кг</span>
                <br></br>
                <span>Радиус действия: 1 725 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,04 мм</span>
              </span>
            </Fragment>
          }
          heading="MX400 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text363">
                KAWASAKI ROBOTICS RA020N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rs020n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RS020N"
          rootClassName="cardroot-class-name99"
        ></Card>
      </div>
      <Cards
        text1={
          <Fragment>
            <span className="kawasaki-robotics-text364">
              Высокоскоростные паллетизирующие роботы грузоподъемностью от 80 до
              700 кг для автоматизации упаковки, укладки продукции и
              внутрискладской логистики.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="kawasaki-robotics-text365">
              Промышленные роботы-паллетайзеры серии CP/ RD
            </span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name10"
      ></Cards>
      <div className="kawasaki-robotics-container5">
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text366">
                <span>Грузоподъёмность: 80 кг</span>
                <br></br>
                <span>Радиус действия: 2 100 мм</span>
                <br></br>
                <span>Количество осей: 5</span>
                <br></br>
                <span>Повторяемость: ±0,07 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text374">
                KAWASAKI ROBOTICS RD080N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_rd080n-300h.webp"
          imageAlt="Промышленный робот Kawasaki RD080N"
          rootClassName="cardroot-class-name109"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text375">
                <span>Грузоподъёмность: 100 кг</span>
                <br className="kawasaki-robotics-text377"></br>
                <span>Радиус действия: 1 725 мм</span>
                <br className="kawasaki-robotics-text379"></br>
                <span>Количество осей: 4</span>
                <br className="kawasaki-robotics-text381"></br>
                <span>Повторяемость: ±0,05 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text383">
                KAWASAKI ROBOTICS CP110L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cp110l-300h.webp"
          imageAlt="Промышленный робот Kawasaki CP110L"
          rootClassName="cardroot-class-name111"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text384">
                <span>Грузоподъёмность: 180 кг</span>
                <br className="kawasaki-robotics-text386"></br>
                <span>Радиус действия: 3 255 мм</span>
                <br className="kawasaki-robotics-text388"></br>
                <span>Количество осей: 4</span>
                <br className="kawasaki-robotics-text390"></br>
                <span>Повторяемость: ±0,5 мм</span>
                <br className="kawasaki-robotics-text392"></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text393">
                KAWASAKI ROBOTICS CP180L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cp180l-300h.webp"
          imageAlt="Промышленный робот Kawasaki CP180L"
          rootClassName="cardroot-class-name110"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text394">
                <span>Грузоподъёмность: 300 кг</span>
                <br className="kawasaki-robotics-text396"></br>
                <span>Радиус действия: 3 255 мм</span>
                <br className="kawasaki-robotics-text398"></br>
                <span>Количество осей: 4</span>
                <br className="kawasaki-robotics-text400"></br>
                <span>Повторяемость: ±0,5 мм</span>
                <br className="kawasaki-robotics-text402"></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text403">
                KAWASAKI ROBOTICS CP300L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cp300l-300h.webp"
          imageAlt="Промышленный робот Kawasaki CP300L"
          rootClassName="cardroot-class-name106"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text404">
                <span>Грузоподъёмность: 500 кг</span>
                <br className="kawasaki-robotics-text406"></br>
                <span>Радиус действия: 3 255 мм</span>
                <br className="kawasaki-robotics-text408"></br>
                <span>Количество осей: 4</span>
                <br className="kawasaki-robotics-text410"></br>
                <span>Повторяемость: ±0,5 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text412">
                KAWASAKI ROBOTICS CP500L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cp300l-300h.webp"
          imageAlt="Промышленный робот Kawasaki CP300L"
          rootClassName="cardroot-class-name105"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text413">
                <span>Грузоподъёмность: 700 кг</span>
                <br className="kawasaki-robotics-text415"></br>
                <span>Радиус действия: 3 255 мм</span>
                <br className="kawasaki-robotics-text417"></br>
                <span>Количество осей: 4</span>
                <br className="kawasaki-robotics-text419"></br>
                <span>Повторяемость: ±0,5 мм</span>
                <br className="kawasaki-robotics-text421"></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text422">
                KAWASAKI ROBOTICS CP700L
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cp300l-300h.webp"
          imageAlt="Промышленный робот Kawasaki CP300L"
          rootClassName="cardroot-class-name104"
        ></Card>
      </div>
      <Cards
        text1={
          <Fragment>
            <span className="kawasaki-robotics-text423">
              Безопасные коллаборативные роботы для совместной работы с
              человеком, автоматизации ручных операций и быстрой интеграции в
              существующее производство.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="kawasaki-robotics-text424">
              Коллаборативные роботы серии CL
            </span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name8"
      ></Cards>
      <div className="kawasaki-robotics-container6">
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text425">
                <span>Грузоподъёмность: 3 кг</span>
                <br></br>
                <span>Радиус действия: 590 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,02 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text433">
                KAWASAKI ROBOTICS CL103N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cl103n-300h.webp"
          imageAlt="Промышленный робот Kawasaki CL103N"
          rootClassName="cardroot-class-name100"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text434">
                <span>Грузоподъёмность: 5 кг</span>
                <br></br>
                <span>Радиус действия: 800 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,02 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text442">
                KAWASAKI ROBOTICS CL105N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cl105n-300h.webp"
          imageAlt="Промышленный робот Kawasaki CL105N"
          rootClassName="cardroot-class-name101"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text443">
                <span>Грузоподъёмность: 8 кг</span>
                <br></br>
                <span>Радиус действия: 1 300 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,02 мм</span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text451">
                KAWASAKI ROBOTICS CL108N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cl108n-300h.webp"
          imageAlt="Промышленный робот Kawasaki CL108N"
          rootClassName="cardroot-class-name102"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kawasaki-robotics-text452">
                <span>Грузоподъёмность: 21 кг</span>
                <br></br>
                <span>Радиус действия: 1 000 мм</span>
                <br></br>
                <span>Количество осей: 6</span>
                <br></br>
                <span>Повторяемость: ±0,02 мм</span>
              </span>
            </Fragment>
          }
          heading="MX600 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kawasaki-robotics-text460">
                KAWASAKI ROBOTICS CL110N
              </span>
            </Fragment>
          }
          imageSrc="/X_additional_pages/kawasaki_cl110n-300h.webp"
          imageAlt="Промышленный робот Kawasaki CL110N"
          rootClassName="cardroot-class-name103"
        ></Card>
      </div>
      <FooterMain></FooterMain>
    </div>
  )
}

export default KawasakiRobotics
